<template>
  <v-container fluid grid-list-lg class="login-container">
    <v-layout row wrap>
      <v-flex xs12 sm10 offset-sm1>
        <v-layout align-center justify-center column pb-2>
          <h2 class="heading-3">Sign in with email</h2>
        </v-layout>

        <v-alert :value="true"  v-if="error != null" type="error" v-html="error.message" ></v-alert>
        <v-alert :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" @submit="login">

            <v-text-field outline v-model="username" :rules="usernameRules" label="Email *"  type="email" required ></v-text-field>

            <v-text-field outline v-model="pass" :rules="passRules" label="Password *" type="password" required ></v-text-field>

            <v-layout row align-center mx-1>
              
              <router-link v-if="!isApp" to="/forgot-password" class="text-button">Forgotten password?</router-link>
              <router-link v-else to="/app-forgot-password" class="text-button">Forgotten password?</router-link>
              <v-spacer />
              <button type="submit" :disabled="!valid" class="button">Login</button>
            </v-layout>

          </v-form>
        </v-layout>
      </v-flex>
    </v-layout>
     
  </v-container>
</template>

<script>
export default {
  name: 'Login',

  computed: {
    isApp: function () {
      if (this.$route.fullPath === '/app-login') {
        return true
      } else {
        return false
      }
    }
  },

  data () {
    
    return {
      valid: true,
      passRules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 8) || 'Remember, your password will have been at least 8 characters, contained a special character and contained both an upper case and a lower case letter'
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid',
        v => (!v.includes(' ')) || 'An email address can not contain any spaces'
      ],
      username: '',
      pass: '',
      error: null,
      success: null,
      loading: false
    }
  },
  mounted () {
    console.log('Login component loaded ', this.$route)
    if(window.location.href.includes("code=true")){ //if the user is referred from a partner site
      localStorage.referrer = document.referrer
      this.success = {message: 'Your membership has been authenticated, please login below.'}
    }
        
  },
  methods: {
    login (e) {
      e.preventDefault()

        this.loading = true
        var email = this.username
        var password = this.pass

        this.$authenticateUser(email, password).subscribe((data) => {
            console.log('login success')
            // mobile app event trigger

            var lastSub = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.LastAuthUser`)
            var idToken = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.idToken`)
            var refreshToken = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.refreshToken`)
            var accessToken = this.$cookie.get(`CognitoIdentityServiceProvider.${process.env.VUE_APP_AWS_CLIENT_ID}.${lastSub}.accessToken`)

            var tokens = {
              'idToken' : idToken,
              'refreshToken' : refreshToken,
              'accessToken' : accessToken
            }

            if (typeof window.android !== 'undefined') { 
              window.android.onSignInSuccess(idToken)
              window.android.passTokens(JSON.stringify(tokens)) 
            }
            if (typeof window.webkit !== 'undefined') { 
              
              window.webkit.messageHandlers.iOS.postMessage(idToken)
              window.webkit.messageHandlers.iOSTokens.postMessage(JSON.stringify(tokens))

            }

            if(localStorage.returnUrl){ // if they were from a trusted referrer and we need to send them back with a JWT
              
              var authUser = this.$getAuthenticatedUser()
              authUser.getSession(function (err, session) {
                // console.log ('jwtToken', session.getIdToken().getJwtToken())
                var jwtToken = session.getIdToken().getJwtToken()

                if(localStorage.responseType == "post"){
                  console.log('post based redirect being performed')
                  var form = document.createElement('form');
                  document.body.appendChild(form);
                  form.method = 'post';
                  form.action = localStorage.returnUrl;
                  var input = document.createElement('input');
                  input.type = 'hidden';
                  input.name = 'token';
                  input.value = jwtToken;
                  form.appendChild(input);
                  console.log('performing redirect post submit to ', localStorage.returnUrl)
                  localStorage.removeItem('returnUrl');
                  localStorage.removeItem('suppressToken');
                  localStorage.removeItem('responseType');
                  form.submit();
                } else {
                  console.log('standard (get) redirect being performed')
                  var firstQueryChar = '?' 
                  if(localStorage.returnUrl.includes('?')){ // account for ? in string
                    firstQueryChar = '&'  
                  }
                  var redirect = localStorage.returnUrl 
                  if(!localStorage.suppressToken){
                    redirect = redirect + firstQueryChar + 'token=' + jwtToken
                  }
                  console.log('redirecting to ' + redirect)
                  localStorage.removeItem('returnUrl');
                  localStorage.removeItem('suppressToken');
                  localStorage.removeItem('responseType');
                  window.location = redirect
                }
              })
              
            } else if(localStorage.referrer){ // if they were a referral sign in then clear this and redirect them.
              var redirect = localStorage.referrer
              console.log('redirecting to ' + redirect)
              localStorage.removeItem('referrer')
              window.location = redirect
            }else{
              this.$router.push("/profile")
            }
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err);
            this.error = err;
            if(err.code === "UnknownError" || err.code === "newPasswordRequired"){
                this.$router.push("/login-set-password");
            }
            if(err.message === 'Incorrect username or password.'){
              err.message = 'Incorrect username or password - If you believe your email is correct please <a href="/forgot-password" class="text-button--login-error">reset your password</a>'
            }
        this.emailVerificationMessage = true;
        });

    }
  }
}
</script>

<style scoped>
.login-container{
  margin-bottom: 70px;
}
.existing-message{
  margin-top: 30px;
  border: 2px solid;
  border-color:rgb(167, 166, 166);
  padding: 10px;
}

.reset-button {
  margin: 0 0 16px;
}

.error {
  display: block;
}
</style>